// Shared display formatters. Keep all number/percent rendering consistent:
// thousands-separated numbers and fixed-precision percents across tables,
// stat cards, and popouts.

/**
 * Format a number with thousands separators and a fixed number of decimals.
 * formatNumber(16062.59)        -> "16,062.59"
 * formatNumber(16062.5, 2)      -> "16,062.50"
 * formatNumber(-320.4, 1)       -> "-320.4"
 */
export function formatNumber(value: number | string, decimals = 2): string {
  const n = typeof value === "string" ? Number(value) : value
  if (!Number.isFinite(n)) return "—"
  return n.toLocaleString("en-US", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  })
}

/**
 * Convert a decimal fraction to a percent string.
 * decimalToPercent(0.0230)      -> "2.30%"
 * decimalToPercent(0.8125, 2)   -> "81.25%"
 */
export function decimalToPercent(value: number | string, decimals = 2): string {
  const n = typeof value === "string" ? Number(value) : value
  if (!Number.isFinite(n)) return "—"
  return `${(n * 100).toFixed(decimals)}%`
}

/**
 * Format an already-percent number to fixed decimals.
 * formatPercent(2.7500)         -> "2.75%"
 */
export function formatPercent(value: number | string, decimals = 2): string {
  const n = typeof value === "string" ? Number(value) : value
  if (!Number.isFinite(n)) return "—"
  return `${n.toFixed(decimals)}%`
}
